import React, { useState, useEffect, Fragment } from "react";
import { Label, Button } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";
import MediaQuery from "react-responsive";
import { getCurrentAccount, getTexts } from "../../reducers/selectors";
import { fetchGetPortfolio, getClientPositionDigital } from "../../services/api/accounts";
import { PortfolioTable } from "./PortfolioTable/PortfolioTable";
import { PortfolioHeader } from "./PortfolioHeader/PortfolioHeader";
import { PortfolioDoghnut, SubAssetClassDoghnut, SubAssetClassDoghnutItems } from "./Charts/Chart";
import { getPersonInfo } from "../../services/api/person";
import { personInfoSet, currentAccountSet } from "../../actions/entities";
import { fetchGetAccounts } from "../../services/api/accounts";
import { RadioButton, RadioButtonGroup } from "../UI/RadioButton/RadioButton";
import { Icons } from "../UI/Icon/Icon";
import { CompositionBar } from "../UI/CompositionBar/CompositionBar";
import { Container } from "../UI/Container/Container";
import { Tooltip } from "../Tooltip/Tooltip";
import GenericButton from "../UI/Button/Button";
import CounterBox from "../UI/Button/CounterBox";
import { Row, Col } from "../UI/Customstrap/Customstrap";
import { Summary } from "./Summary/Summary";
import { TitleLabel } from "../UI/TitleLabel/TitleLabel";
import { AssetClass } from "./AssetClass/AssetClass";

import style from "./Portfolio.scss";

const allowedCurrencies = {
  ALL: "ALL",
  PYG: "PYG",
  USD: "USD",
};

export const Portfolio = () => {
  const [loadingPosition, setLoadingPosition] = useState(true);
  const [portfolio, setPortfolio] = useState(null);
  const [portfolioTotal, setPortfolioTotal] = useState(0);
  const [fx, setFx] = useState(1);
  const [portfolioDate, setPortfolioDate] = useState(new Date().toISOString().slice(0, 10));
  const currentAccount = useSelector(getCurrentAccount);
  const texts = useSelector(getTexts);
  const [activeCurrency, setActiveCurrency] = useState(allowedCurrencies.ALL);
  const [activePortfolio, setActivePortfolio] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoadingPosition(true);
    setPortfolio(null);

    if (currentAccount.AccountNumber) {
      fetchGetPortfolio(currentAccount.AccountNumber, portfolioDate)
        .then(({ response }) => {
          setPortfolio(response);
          // setPortfolioTotal(+response.position.valueTotalUSD + +response.positionPYG.valueTotalUSD);
          //  setFx(response.currencypairprice.rawprice);
          setLoadingPosition(false);
        })
        .catch((err) => {
          console.error(err);
          setLoadingPosition(false);
        });
    }
    if (currentAccount.noAccounts) {
      setLoadingPosition(false);
    }
  }, [currentAccount, portfolioDate]);

  useEffect(() => {
    if (portfolio && !loadingPosition) {
      let newActivePortfolio;
      switch (activeCurrency) {
        case allowedCurrencies.ALL:
          newActivePortfolio = portfolio.positionUSD;
          break;
        case allowedCurrencies.PYG:
          newActivePortfolio = portfolio.positionPYG;
          break;
        case allowedCurrencies.USD:
          newActivePortfolio = portfolio.position;
          break;
      }

      newActivePortfolio.assetClass = newActivePortfolio.assetClass.map((assetClass) => {
        assetClass.percentage =
          Math.round(((+assetClass.totalUSD * 100) / +newActivePortfolio.portfolioTotalUSD) * 100) / 100;
        return assetClass;
      });
      newActivePortfolio.assetClass = newActivePortfolio.assetClass.sort((a, b) => {
        return a.percentage < b.percentage ? 1 : -1;
      });
      // if (newActivePortfolio && newActivePortfolio.assetClass) {
      // } else {
      //   return (newActivePortfolio = "20%");
      // }

      const subAssetClasses = [];
      newActivePortfolio.assetClass.map((assetClass) => {
        assetClass.subAssetClass.map((subAssetClassItem) => {
          subAssetClasses.push(subAssetClassItem);
        });
      });

      newActivePortfolio.subAssetClasses = subAssetClasses;
      setActivePortfolio(newActivePortfolio);
    }
  }, [activeCurrency, portfolio, loadingPosition]);

  useEffect(() => {
    getPersonInfo()
      .then(({ response }) => {
        dispatch(personInfoSet(response.personInfo));
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    fetchGetAccounts()
      .then((r) => {
        if (r.response.accounts.length > 0) {
          //handleChangeAccount(r.response.accounts[0]);
        } else {
          handleChangeAccount({
            noAccounts: true,
            AccountNumber: 0,
            AccountEmail: "",
            AccountName: "",
            advisorName: "",
            advisorFirstLastName: "",
            advisorEmail: "",
            advisorPhone: "",
          });
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const handleChangeAccount = (newAccount) => {
    dispatch(currentAccountSet({ ...currentAccount, ...newAccount, AccountNumber: newAccount.number }));
  };

  const handleChangeDate = (date) => {
    setPortfolioDate(() => date);
  };

  const handleActiveCurrency = (name) => {
    setActiveCurrency(allowedCurrencies[name]);
  };

  if (loadingPosition)
    return (
      <div className={style.fullCenter}>
        <CircularProgress />
      </div>
    );

  if (currentAccount.noAccounts)
    return (
      <Row>
        <Col>
          <span>No hay cuentas asociadas</span>
        </Col>
      </Row>
    );

  return (
    <Row>
      <Col xs={12} xl={9}>
        <Row className={style.headerTitle}>
          <Label>Portafolio</Label>
        </Row>
        <MediaQuery maxWidth={576}>
          <Col xs={12} xl={3}>
            <Container>
              <Summary portfolio={portfolio} />
            </Container>
          </Col>
        </MediaQuery>
        <Row>
          <Col xs={12}>
            <Container className={style.investments}>
              <Row>
                <Col>
                  <TitleLabel className={style.titleInvestments} label="Inversiones" />
                </Col>
                <Col className={style.colCurrency}>
                  <RadioButtonGroup>
                    <RadioButton
                      label="Todos"
                      onClick={handleActiveCurrency}
                      name={allowedCurrencies.ALL}
                      active={activeCurrency === allowedCurrencies.ALL}
                    />
                    <RadioButton
                      label="Guaraníes"
                      onClick={handleActiveCurrency}
                      name={allowedCurrencies.PYG}
                      active={activeCurrency === allowedCurrencies.PYG}
                    />
                    <RadioButton
                      label="Dólares"
                      onClick={handleActiveCurrency}
                      name={allowedCurrencies.USD}
                      active={activeCurrency === allowedCurrencies.USD}
                    />
                  </RadioButtonGroup>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Container>
              {activePortfolio && (
                <Row className={style.spacedRow}>
                  <Col xs={12} xl={7} className={style.compositionSectionAsset}>
                    <SectionTitle title="Composición por tipo de activo" />
                    <CompositionBar data={activePortfolio.assetClass} />
                  </Col>
                  <Col xs={12} xl={5} className={style.compositionSectionSubAsset}>
                    <Row className={style.instrumentRow}>
                      <SectionTitle title="Composición por instrumento" />
                      <Col xs={12} sm={6}>
                        <SubAssetClassDoghnut subAssetClasses={activePortfolio.subAssetClasses} />
                      </Col>
                      <Col xs={12} sm={6}>
                        <SubAssetClassDoghnutItems subAssetClasses={activePortfolio.subAssetClasses} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Container>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Container>
              {activePortfolio && (
                <AssetClass
                  assetClasses={activePortfolio.assetClass}
                  portfolioTotal={activePortfolio.valueTotalUSD}
                  activeCurrency={activeCurrency}
                  fx={portfolio.currencypairprice.rawprice}
                />
              )}
            </Container>
          </Col>
        </Row>
      </Col>
      <MediaQuery minWidth={576}>
        <Col xs={12} xl={3}>
          <Container>
            <Summary portfolio={portfolio} />
          </Container>
        </Col>
      </MediaQuery>
    </Row>
  );
};

// Composición por tipo de activo

const SectionTitle = ({ title }) => (
  <Fragment>
    <Label className={style.cardLabel}>{title}</Label>
    <hr className={style.cardLabelLine} />
  </Fragment>
);
